import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.5.8_next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.95.1__react@19.2.1_typescript@5.9.3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/[locale]/(pages)/contact/_components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(main)/[locale]/(pages)/contact/page.module.scss");
